module.exports = __webpack_public_path__ + "img/appstore.2a7f3a86.png";